module.exports = __webpack_public_path__ + "img/Platform_Gradients-1.c26d6e3e.jpg";